module.exports = __webpack_public_path__ + "img/film-1.0d198149.png";